import React, { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {Link, useHistory, withRouter } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  ROUTES,
  EMPTY_STRING,
  configurationsConstants,
} from "../../../../constants";
import { assetsConstants } from "../../../../constants/assets.constants";
import * as modalConstants from "../../../../constants/modal.constants.js";
import { NavigateToPath } from "../../../../system/history.js";
import CheckBox from "../../../../shared/components/Fields/CheckBox";
import InputField from "../../../../shared/components/Fields/InputField";
import SideImage from "../../../../shared/components/SideImage/SideImage";
import { loginActions } from "../../../../redux/actions";

const SignUpForm = (props) => {
  const { t } = useTranslation("common");

  const history = useHistory();

  const [isPasswordSame, setIsPasswordSame] = useState(true);
  /* eslint-disable */
  const [shouldSignupForShutterbNews, setSignupForShutterbNews] =
    useState(false);

  // when user clicks on Login button
  const handleSubmit = (event, values) => {
    if (values.password !== values.confirmPassword) {
      setIsPasswordSame(false);
      return;
    } else {
      setIsPasswordSame(true);
    }

    const handleSuccess = () => {
      if (props.isPage) {
        NavigateToPath(history, `${ROUTES.CUSTOMER_LOGIN}`);
      }
    };

    props.onSignupClick(
      {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
      },
      props.setIsModalOpen,
      props.setFormSelect,
      handleSuccess
    );
  };

  return (
    <>
      <SideImage
        showBackButton={props.showBackButton ?? true}
        imageUrl={assetsConstants.CUSTOMER_LOGIN_IMAGE_URL}
        isAllowModal={props.isAllowModal}
      >
        <div
          className={`login-form ${
            props.isAllowModal ? "login-form-modal px-3 pb-4" : EMPTY_STRING
          }`}
        >
          {!props.isPage && (
            <button
              id="cancel-icon"
              onClick={() => props.setIsModalOpen(false)}
            >
              <span>X</span>
            </button>
          )}
          <AvForm className="form_Display_Flex" onValidSubmit={handleSubmit} autoComplete="off">
            <div className={`${props.isAllowModal ? "pt-0" : "pt-3"}`}>
              <div className="d-flex align-items-center position-relative my-md-2 my-4">
                <h2 className="text-center form-heading w-100 mb-0 pt-md-5">
                  signup
                </h2>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="">
                  <AvField
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    maxLength={35}
                    className="form-control"
                    label={
                      <span className="form-label label-content-600">
                        First Name
                      </span>
                    }
                    pattern="^[a-z,A-Z,0-9].{0,35}$"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t("this_field_is_required"),
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="">
                  <AvField
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    className="form-control"
                    label={
                      <span className="form-label label-content-600">
                        Last Name
                      </span>
                    }
                    maxLength={35}
                    pattern="^[a-z,A-Z,0-9].{0,35}$"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t("this_field_is_required"),
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="">
                  <AvField
                    type="email"
                    name="email"
                    label={
                      <span className="form-label label-content-600">
                        Email
                      </span>
                    }
                    placeholder="Email"
                    className="form-control"
                    maxLength={configurationsConstants.EMAIL_INPUT_LENGTH}
                    pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: t("this_field_is_required"),
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="form__form-group">
              <div className="form__form-group-field">
                <InputField
                  label={
                    <span className="form-label label-content-600">
                      Password
                    </span>
                  }
                  required
                  type="password"
                  name="password"
                  placeholder="Password"
                  maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                  pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]).{6,}$"
                  errorMessage="minimum 6 characters, including number, special, lower & uppercase characters are required"
                  patternErrorMessage="minimum 6 characters, including number, special, lower & uppercase characters are required"
                />
              </div>
            </div>
            <div className="form__form-group mt-2">
              <div className="form__form-group-field">
                <InputField
                  required
                  type="password"
                  name="confirmPassword"
                  label={
                    <span className="form-label label-content-600">
                      Confirm Password
                    </span>
                  }
                  placeholder="Confirm Password"
                  maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                  pattern=""
                  errorMessage={t("this_field_is_required")}
                  onChange={() => {
                    !isPasswordSame && setIsPasswordSame(true);
                  }}
                />
                {!isPasswordSame && (
                  <p className="custom-error p-0 m-0">
                    password & confirm password does not match.
                  </p>
                )}
              </div>
            </div>

            <div class="my-2">
              <CheckBox
                containerClass={"teal-checkbox"}
                checked={shouldSignupForShutterbNews}
                setChecked={setSignupForShutterbNews}
                labelText={
                  "Sign me up for shutterb news, updates and promotions."
                }
              />
            </div>
            <div className="form__form-group mb-4">
              <div className="form__form-group-field">
                <div className="account__btns m-0">
                  <button className="btn-teal w-100">SignUp</button>
                </div>
              </div>
            </div>
          </AvForm>
          <div className="form__form-group align-self-center">
            <p className="p-0 m-0 sign-up-shutterb ">
              Already have an account{" "}
              <Link
                to={ROUTES.CUSTOMER_LOGIN}
                onClick={(e) => {
                  if (props.isAllowModal) {
                    e.preventDefault();
                    props?.setFormSelect(modalConstants.LOGIN_FORM);
                  }
                }}
                className="underline teal-text"
              >
                Login Here
              </Link>
            </p>
          </div>
        </div>
      </SideImage>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerActions: state.system.spinnerActions,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  onSignupClick: (data, setIsModalOpen, setFormSelect, onSuccess) =>
    dispatch(
      loginActions.signup(data, setIsModalOpen, setFormSelect, onSuccess)
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SignUpForm));
